import { render, staticRenderFns } from "./serviceList.vue?vue&type=template&id=6999299c&scoped=true&"
import script from "./serviceList.vue?vue&type=script&lang=js&"
export * from "./serviceList.vue?vue&type=script&lang=js&"
import style0 from "./serviceList.vue?vue&type=style&index=0&id=6999299c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6999299c",
  null
  
)

export default component.exports